import { SignupCoreServicesEntity } from '@tracking/trackingEvents';

// Possible combinations: https://github.com/utilitywarehouse/dataform-customer/blob/fbb5044b84e7155377df40ab560f1b7c93cdfe1e/definitions/functions/getCoreServiceCombinationsV2.sqlx#L21-L53
const getGroupCombinations = (coreServicesState: SignupCoreServicesEntity) => {
  const { energy, broadband, mobile, insurance, multiple_sims_selected } =
    coreServicesState;
  const hasMultiMobile = multiple_sims_selected;

  // 5 services combination
  if (hasMultiMobile && energy && broadband && insurance) {
    return '5_Broadband_Energy_Insurance_MultiMobile';
  }

  // 4 services combinations
  if (hasMultiMobile && energy && broadband) {
    return '4_Broadband_Energy_MultiMobile';
  }
  if (hasMultiMobile && energy && insurance) {
    return '4_Energy_Insurance_MultiMobile';
  }
  if (hasMultiMobile && broadband && insurance) {
    return '4_Broadband_Insurance_MultiMobile';
  }
  if (mobile && energy && broadband && insurance) {
    return '4_Broadband_Energy_Insurance_Mobile';
  }

  // 3 services combinations
  if (mobile && energy && broadband) {
    return '3_Broadband_Energy_Mobile';
  }
  if (hasMultiMobile && energy) {
    return '3_Energy_MultiMobile';
  }
  if (hasMultiMobile && broadband) {
    return '3_Broadband_MultiMobile';
  }
  if (hasMultiMobile && insurance) {
    return '3_Insurance_MultiMobile';
  }
  if (insurance && broadband && energy) {
    return '3_Broadband_Energy_Insurance';
  }
  if (insurance && broadband && mobile) {
    return '3_Broadband_Insurance_Mobile';
  }
  if (insurance && energy && mobile) {
    return '3_Energy_Insurance_Mobile';
  }

  // 2 services combinations
  if (mobile && broadband) {
    return '2_Broadband_Mobile';
  }
  if (mobile && energy) {
    return '2_Energy_Mobile';
  }
  if (energy && broadband) {
    return '2_Broadband_Energy';
  }
  if (insurance && broadband) {
    return '2_Broadband_Insurance';
  }
  if (insurance && energy) {
    return '2_Energy_Insurance';
  }
  if (insurance && mobile) {
    return '2_Mobile_Insurance';
  }
  // Possible to be in the tracking context, but not possible for placing an order
  if (hasMultiMobile) {
    return '2_MultiMobile';
  }

  // Single service
  if (energy) {
    return '1_Energy_Only';
  }
  if (broadband) {
    return '1_Broadband_Only';
  }
  if (mobile) {
    return '1_Mobile_Only';
  }
  if (insurance) {
    return '1_Insurance_Only';
  }

  return 'Uncategorised';
};

export { getGroupCombinations };
